import call from "../lib/core/functional/call.js";
import noop from "../lib/core/functional/noop.js";
import loadExternalResource from "./loadExternalResource";

function isFbHack(src) {
    try {
        const url = new URL(src);
        return url.host === "connect.facebook.net";
    } catch (error) {
        return false;
    }
}

function loadTag(src, callback, onError) {
    const selector = `script[src="${src}"]`;
    const element = document.createElement("script");
    element.src = src;
    element.async = true;
    loadExternalResource(selector, element, callback || noop, onError || noop);
}

const BACKUP_INSTAGRAM =
    "https://s3.amazonaws.com/roar-assets-auto.rbl.ms/shared/instagram/embed.js";

export const IG_PATH = "https://www.instagram.com/embed.js";
export const THREADS_PATH = "https://www.threads.com/embed.js";

const callbackRunner = call();

function runHolds(holds) {
    holds.forEach(callbackRunner);
}

function makeLifeCycleHold(siblingPath) {
    const hold = {
        get sibling() {
            return LIFECYCLE_HACKS[siblingPath];
        },
        lib: null,
        inProgress: false,
        holds: [],
        addHold(cb) {
            hold.holds.push(cb);
        },
        clean() {
            window.instgrm = undefined;
        },
        onLoad(cb) {
            return function () {
                hold.lib = { ...window.instgrm };
                hold.inProgress = false;
                cb();
                const pending = hold.holds.slice();
                hold.holds = [];
                runHolds(pending);
            };
        },
    };

    return hold;
}

export const LIFECYCLE_HACKS = {
    [IG_PATH]: makeLifeCycleHold(THREADS_PATH),
    [THREADS_PATH]: makeLifeCycleHold(IG_PATH),
};

export default function loadExternalScript(src, callback, onError) {
    let onLoad = callback;

    if (isFbHack(src)) {
        function onIgReady() {
            loadTag(src, onLoad, onError);
        }
        loadExternalScript(IG_PATH, onIgReady);
        return;
    }

    if (src in LIFECYCLE_HACKS) {
        const hack = LIFECYCLE_HACKS[src];

        if (hack.lib == null) {
            const sibling = hack.sibling;

            if (sibling.inProgress) {
                sibling.addHold(() => loadExternalScript(src, callback, onError));
                return;
            }

            hack.clean();
            hack.inProgress = true;
            onLoad = hack.onLoad(callback);
        }
    }

    let finalSrc = src;

    if (src === IG_PATH) {
        finalSrc = BACKUP_INSTAGRAM;
    }

    loadTag(finalSrc, onLoad, onError);
}
